import styles from './renewals.module.scss';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { booleanHeader, Box, Container, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, SumRows, textHeader } from '@frontend-workspace/react-shared-lib';
import FullTable from '../../full-table/full-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface RenewalsProps { }

export function Renewals(props: RenewalsProps) {
  const { t } = useTranslation();
  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.renewals")} subtitle={`(${t("standard.reports")})`} />
            <FullTable
              url='reports/renewed-licenses'
              tableConfigName="renewalsReport"
              headers={CreateHeaders([
                textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
                textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("place", t("standard.place"), HeaderSizeEnum.MEDIUM),
                textHeader("contractResponsible", t("standard.contractManager"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("sellerName", t("standard.seller"), HeaderSizeEnum.LARGE),
                textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
                textHeader("type", t("standard.type"), HeaderSizeEnum.MEDIUM),
                textHeader("interval", t("standard.period"), HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("seats", "Seter", HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                textHeader("recurringVismaId", t("standard.recurringItem"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("productName", t("standard.productName"), HeaderSizeEnum.EXTRA_LARGE),
                dateHeader("nextInvoiceDate", t("standard.invoiceDate")),
                currencyHeader("invoiceAmount", t("standard.invoiceAmount"), HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                currencyHeader("recurringCostPrice", t("standard.costPrice"), HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                currencyHeader("netGain", "DB", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                textHeader("nimbusCode", t("standard.code"), HeaderSizeEnum.SMALL),
                textHeader("productGroup", t("standard.productGroup"), HeaderSizeEnum.LARGE),
                dateHeader("terminatonDate", t("standard.expiryDate")),
                textHeader("timesInvoicedInPeriod", t("renewalsGrid.timesInvoicedInPeriod"), HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                booleanHeader("isActiveNextInvoice", t("renewalsGrid.activeNextInvoice")),
                booleanHeader("isActive", t("standard.active"))
              ])}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Renewals;